import { defineAsyncComponent } from 'vue';

export const TableFilter = defineAsyncComponent(() => import('./UserFilter.vue'));
export const TableEdit = defineAsyncComponent(() => import('./UserEdit.vue'));
export const TableDetail = defineAsyncComponent(() => import('./UserDetail.vue'));
export const TableTopUser = defineAsyncComponent(() => import('./TableTopUser.vue'));
export const DialogConfirmation = defineAsyncComponent(() => import('./DialogConfirmationUser.vue'));
